"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoopNetworkClientMessageSender = void 0;
class NoopNetworkClientMessageSender {
    sendToTopic(topic, _message) {
        throw new Error(`No message sender to send to ${topic}`);
    }
}
exports.NoopNetworkClientMessageSender = NoopNetworkClientMessageSender;
